const crypto = require('crypto');
const getConfig = require('next/config');

const encrypt = (text) => {
    const { publicRuntimeConfig } = getConfig.default();
    const iv = publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_KEY.substr(0, 16);
    const cipher = crypto.createCipheriv(
        publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_ALGORITHM,
        publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_KEY,
        iv,
    );
    let crypted = cipher.update(text, 'utf8', 'base64');
    crypted += cipher.final('base64');
    return crypted;
};

const decrypt = (text) => {
    const { publicRuntimeConfig } = getConfig.default();
    const iv = publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_KEY.substr(0, 16);
    const decipher = crypto.createDecipheriv(
        publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_ALGORITHM,
        publicRuntimeConfig.NEXT_PUBLIC_ENCRYPTION_KEY,
        iv,
    );
    let dec = decipher.update(text, 'base64', 'utf8');
    dec += decipher.final('utf8');
    return dec;
};

module.exports = {
    encrypt,
    decrypt,
};
